<template>
  <div class="resources-editor">
    <divider orientation="left">Документы</divider>
    <collapse accordion>
      <panel :name="item.name" v-for="item in fileTypes" :key="item.id">
        {{ item.name }} ({{ lists[item.name] ? lists[item.name].length : 0 }})
        <div slot="content">
          <inline-loader v-if="loading" :loading="loading" />
          <Upload
            v-else
            multiple
            type="drag"
            :ref="item.name"
            :action="uploadURL"
            :headers="uploadHeaders"
            :on-success="response => onUploadSuccess(item.id, response)"
            :on-error="onUploadError"
            :default-file-list="files[item.name] || []"
            :show-upload-list="false"
            @click.native="clickHandler(item, $event)"
          >
            <div style="padding: 8px 0">
              <icon type="ios-cloud-upload" size="32" style="color: #4484ce" />
              <p style="font-size: 12px">
                Перетащите необходимые файлы для загрузки
              </p>
            </div>
          </Upload>
          <resources-upload-list
            v-if="lists[item.name] && lists[item.name].length"
            style="margin-top: 8px"
            :list="lists[item.name]"
            @handle-click="handleFileClick"
            @handle-remove="file => handleFileRemove(file, item.name)"
          />
        </div>
      </panel>
    </collapse>

    <modal :z-index="2000" v-model="deleteModal" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление материалов</span>
      </p>
      <div style="text-align:center">
        <p class="ms-text">Вы уверены, что хотите удалить данный документ?</p>
      </div>
      <div slot="footer">
        <i-button
          type="error"
          size="default"
          long
          :loading="deleteLoading"
          @click="deleteFile"
        >
          Удалить
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import ResourcesUploadList from './resource-upload-list'
import { downloadFile } from '@/utils'
import { mainUrl } from '@/config/urls'

export default {
  props: ['parent', 'type'],
  components: {
    InlineLoader,
    ResourcesUploadList
  },
  watch: {
    'parent.id': function (id) {
      if (id) this.getDocuments()
      else {
        this.files = {}
        this.lists = {}
      }
    }
  },
  data () {
    return {
      token: this.$store.state.auth.token,
      downloadUrl: `${mainUrl}/api/download_resource`,
      uploadURL: `${mainUrl}/api/upload_resource`,
      uploadHeaders: { token: this.$store.state.auth.token },
      files: {},
      lists: {},
      fileTypes: [],
      loading: false,
      deleteModal: false,
      deleteLoading: false,
      deletingId: null
    }
  },
  methods: {
    clickHandler (type, e) {
      const { tagName, textContent } = e.target
      if (tagName !== 'SPAN') return

      const file = this.files[type.name].find(
        f => f.file_name === textContent.trim()
      )
      if (!file) return
      const id = file.resource_id
      const url = `${this.downloadUrl}/${id}?access_token=${this.token}`
      downloadFile(url)
    },
    handleFileClick (resource_id) {
      const url = `${this.downloadUrl}/${resource_id}?access_token=${
        this.token
      }`
      downloadFile(url)
    },
    handleFileRemove (file, name) {
      this.deletingId = file.id || file.response[0]
      this.deleteModal = true

      if (!this.parent.id) {
        this.$refs[name][0].fileList = this.$refs[name][0].fileList.filter(
          f => f.uid !== file.uid
        )
      }
    },
    async deleteFile () {
      const id = this.deletingId

      if (this.parent.id) {
        try {
          this.deleteLoading = true
          const url = `page/document?object_id=${this.parent.id}&object_type=${
            this.type
          }`
          const data = [{ id, disabled: true }]
          await this.$store.dispatch('POST_REQUEST', { url, data })
          await this.getDocuments(true)
          this.$emit('update')
          this.deleteLoading = false
          this.deleteModal = false
          this.deletingId = null
        } catch (error) {
          console.log(error)
          this.deleteLoading = false
        }
      } else {
        this.$set(
          this.parent,
          'object_resources',
          this.parent.object_resources.filter(f => f.resource_id !== id)
        )

        setTimeout(() => this.updateRefs(), 100)

        this.$emit('update')
        this.deleteLoading = false
        this.deleteModal = false
        this.deletingId = null
      }
    },
    async getFileTypes () {
      try {
        const url = `objectInfo/file_types`
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        this.fileTypes = data.filter(t => t.object_name === this.type)
      } catch (error) {
        console.log(error)
      }
    },
    async getDocuments (noloading) {
      try {
        if (!noloading) this.loading = true
        const url = `page/document?object_id=${this.parent.id}&object_type=${
          this.type
        }`
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        const commonData = data['Общее']
        let newResources = []

        Object.keys(commonData).forEach(category => {
          commonData[category].forEach(f => (f.name = f.file_name))
          newResources = [...newResources, ...commonData[category]]
        })

        this.$set(this.parent, 'object_resources', newResources)
        this.$set(this, 'files', commonData)
        setTimeout(() => this.createRefs(), 100)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async onUploadSuccess (file_type_id, response) {
      const [resource_id] = response

      const data = [
        {
          file_type_id,
          resource_id,
          object_type: this.type
        }
      ]

      if (this.parent.id) {
        try {
          const url = `page/document?object_id=${this.parent.id}&object_type=${
            this.type
          }`
          await this.$store.dispatch('POST_REQUEST', { url, data })
          await this.getDocuments(true)
          this.$emit('update')
          this.$Message.success('Файл успешно загружен')
        } catch (error) {
          console.log(error)
        }
      } else {
        this.parent.object_resources.push(data[0])

        setTimeout(() => this.updateRefs(), 100)
      }
    },
    onUploadError () {
      this.$Message.error('Произошла ошибка при загрузке файла')
    },
    createRefs () {
      for (const name in this.files) {
        this.$set(this.lists, name, this.$refs[name][0].fileList)
      }
    },
    updateRefs () {
      this.fileTypes.forEach(({ name }) => {
        this.$set(this.files, name, this.$refs[name][0].fileList)
        this.$set(this.lists, name, this.$refs[name][0].fileList)
      })
    }
  },
  created () {
    this.getFileTypes()
  }
}
</script>

<style></style>
